// extracted by mini-css-extract-plugin
export default {"clientLogo":"ClientLogo_clientLogo__LjNEB"};